import { render, staticRenderFns } from "./LaborEfficiencyRatio.vue?vue&type=template&id=f4757078"
import script from "./LaborEfficiencyRatio.vue?vue&type=script&lang=js"
export * from "./LaborEfficiencyRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports